export function getCampaignRecipientTimelineDate(recipient) {
  if (!recipient) return null;

  if (recipient.status === 'sent') {
    return recipient.sentAt || recipient.sendAt || recipient.updatedAt || recipient.createdAt || null;
  }

  return recipient.sendAt || recipient.updatedAt || recipient.createdAt || null;
}
